import React, { PropTypes } from 'react';
import { FormGroup, Table, Radio } from 'react-bootstrap';

const CoverageTypeInfo = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <h3 className="ebaoUtil__HeaderThree">Coverage Type Information</h3>
        <FormGroup controlId="mainCoverageType">
        <Table responsive>
          <thead>
            <tr>
              <th colSpan="2">Please choose a main coverage type</th>
              <th>Gross Premium</th>
              <th>Net Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><Radio
                name="coverageType"
                value="comprehensive"
                onChange={props.handleChangeMainCoverageType}
                checked={props.mainCoverType.comprehensive.checked === true} />
              </td>
              <td>Comprehensive</td>
              <td>{props.mainCoverType.comprehensive.grossPremium}</td>
              <td>{props.mainCoverType.comprehensive.netPremium}</td>
            </tr>
            <tr>
              <td><Radio
                name="coverageType"
                value="thirdParty"
                checked={props.mainCoverType.thirdParty.checked === true}
                onChange={props.handleChangeMainCoverageType} />
              </td>
              <td>Third Party</td>
              <td>{props.mainCoverType.thirdParty.grossPremium}</td>
              <td>{props.mainCoverType.thirdParty.netPremium}</td>
            </tr>
          </tbody>
          </Table>
        </FormGroup>
    </div>
  )
}

CoverageTypeInfo.propTypes = {
  mainCoverType: PropTypes.object,
  handleChangeMainCoverageType: PropTypes.func
};

export default CoverageTypeInfo;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/coverageTypeInfo/CoverageTypeInfo.js